export default "__VITE_PUBLIC_ASSET__95882ec9__"